import React from 'react';
import { Box, Button, Flex, Paper, Text, ThemeIcon } from '@mantine/core';
import { IconArrowRight, IconSparkles } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

interface TipsCardProps {
  onCreate: () => void;
}

export const TipsCard: React.FC<TipsCardProps> = ({ onCreate }) => {
  const { t } = useTranslation();
  return (
    <Paper
      radius="lg"
      p="md"
      style={{
        background: 'var(--mantine-primary-color-light)',
        border: 'none',
      }}
    >
      <Flex align="flex-start" gap="sm">
        <ThemeIcon size={32} radius="md" color="teal" variant="light">
          <IconSparkles size={16} />
        </ThemeIcon>
        <Box style={{ flex: 1, minWidth: 0 }}>
          <Text size="sm" fw={600} mb={4}>
            {t('perfReview.adminHome.tips.title')}
          </Text>
          <Text size="xs" c="dimmed" lh={1.5} mb="sm">
            {t('perfReview.adminHome.tips.body')}
          </Text>
          <Button
            size="xs"
            variant="default"
            rightSection={<IconArrowRight size={14} />}
            onClick={onCreate}
          >
            {t('perfReview.adminHome.tips.cta')}
          </Button>
        </Box>
      </Flex>
    </Paper>
  );
};
